"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchReloadCache = exports.init = exports.initV2 = exports.Config = void 0;
var axios_1 = require("axios");
var helper_1 = require("./utils/helper");
var constants_1 = require("./utils/constants");
var distance = require("./distance");
var date = require("./date");
var phone = require("./phone");
__exportStar(require("./distance/interface"), exports);
__exportStar(require("./currency/interface"), exports);
__exportStar(require("./date/interface"), exports);
__exportStar(require("./phone/interface"), exports);
__exportStar(require("./pushConfig"), exports);
__exportStar(require("./common/interface"), exports);
var Config = /** @class */ (function () {
    function Config() {
    }
    Config.initData = function (_a) {
        var locale = _a.locale, country = _a.country, config = _a.config, _b = _a.ifCache, ifCache = _b === void 0 ? true : _b, options = _a.options;
        Config.locale = locale;
        Config.country = country;
        Config.config = config;
        Config.ifCache = ifCache;
        Config.options = options;
    };
    /**
     * 创建 IndexedDB 数据库和对象存储
     * @returns
     */
    Config.createIndexedDB = function () {
        var dbName = 'ElvishDB';
        var version = 1;
        return new Promise(function (resolve, reject) {
            if (typeof window !== 'undefined') {
                var request = window.indexedDB.open(dbName, version);
                // 如果指定的版本号，大于数据库的实际版本号，就会发生数据库升级事件
                request.onupgradeneeded = function (event) {
                    var _a;
                    var db = (_a = event.target) === null || _a === void 0 ? void 0 : _a.result;
                    if (!db.objectStoreNames.contains(dbName)) {
                        db.createObjectStore(dbName, { keyPath: 'name' });
                    }
                };
                request.onsuccess = function (event) {
                    var _a;
                    resolve((_a = event.target) === null || _a === void 0 ? void 0 : _a.result);
                };
                request.onerror = function (event) {
                    var _a;
                    reject((_a = event.target) === null || _a === void 0 ? void 0 : _a.error);
                };
            }
            else {
                reject(new Error('Not in a browser environment.'));
            }
        });
    };
    /**
     * 从 indexedDB 中获取缓存数据
     * @returns
     */
    Config.getFromIndexedDB = function (configName) {
        return __awaiter(this, void 0, void 0, function () {
            var db, transaction, objectStore, requestGet_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof window !== 'undefined')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Config.createIndexedDB()];
                    case 1:
                        db = (_a.sent());
                        transaction = db.transaction(['ElvishDB'], 'readonly');
                        objectStore = transaction.objectStore('ElvishDB');
                        requestGet_1 = objectStore.get(configName);
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                requestGet_1.onsuccess = function () {
                                    if (requestGet_1.result) {
                                        resolve(requestGet_1.result.data);
                                    }
                                    else {
                                        resolve(null);
                                    }
                                };
                                requestGet_1.onerror = function (error) {
                                    console.error('Error in getFromIndexedDB:', error);
                                    reject(error);
                                };
                            })];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * 拉取阿波罗配置失败后
     * 浏览器环境优先使用 indexedDB 里的缓存，解析失败则再重新拉取阿波罗
     * node环境则使用本地的兜底文件
     * @return {void}
     */
    Config.handleError = function (err) {
        return __awaiter(this, void 0, void 0, function () {
            var apolloConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Config.getFromIndexedDB(constants_1.ConfigMap.ELVISHCONFIG)];
                    case 1:
                        apolloConfig = _a.sent();
                        if (apolloConfig) {
                            Config.apollo = apolloConfig;
                        }
                        else {
                            console.warn("Elvish Fetch Warning: ".concat(err.message || '请求apollo配置出错且无缓存可用'));
                            // 不再抛出错误，改为使用本地文件兜底
                            if (typeof window !== 'undefined') {
                                Config.apollo = (0, helper_1.getApolloConfigFromLocal)(constants_1.Flag.APOLLO);
                            }
                            if (!Config.apollo) {
                                throw Error("Elvish Fetch Error: ".concat(err.message || "\u672C\u5730apollo\u914D\u7F6E\u83B7\u53D6\u5931\u8D25"));
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 将配置存储到 IndexedDB
     */
    Config.storeConfigInIndexedDB = function (configName, config) {
        return __awaiter(this, void 0, void 0, function () {
            var db, transaction, objectStore;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof window !== 'undefined')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Config.createIndexedDB()];
                    case 1:
                        db = (_a.sent());
                        transaction = db.transaction(['ElvishDB'], 'readwrite');
                        objectStore = transaction.objectStore('ElvishDB');
                        return [2 /*return*/, objectStore.add({ name: configName, data: config })];
                    case 2: return [2 /*return*/, Promise.reject(new Error('Not in a browser environment for storing in IndexedDB.'))];
                }
            });
        });
    };
    /**
     * 拉取阿波罗配置, 并将配置缓存
     * @return {void}
     */
    Config.getFromApollo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.get(helper_1.apolloCDNPath)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.data];
                    case 2:
                        config = _a.sent();
                        if (typeof window !== 'undefined') {
                            Config.apollo = config;
                            Config.storeConfigInIndexedDB(constants_1.ConfigMap.ELVISHCONFIG, config)
                                .then(function () { return console.log("".concat(constants_1.ConfigMap.ELVISHCONFIG, "\u6570\u636E\u5B58\u50A8\u6210\u529F\uFF01")); })
                                .catch(function (error) {
                                console.warn("".concat(constants_1.ConfigMap.ELVISHCONFIG, "\u6570\u636E\u5B58\u50A8\u5931\u8D25:"), error);
                                Config.handleError(error);
                            });
                        }
                        else {
                            console.warn('Not in a browser environment for storing Apollo config.');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 拉取阿波罗配置
     * @return {Record<string, any>}
     */
    Config.handleGetFromApolloError = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Config.getFromApollo()
                        .then(function (res) {
                        return res;
                    })
                        .catch(function (err) {
                        console.warn("----Elvish Warning: ".concat(err || 'require apollo config error'));
                    })];
            });
        });
    };
    /**
     * 拉取阿波罗配置
     * @return {Promise<void>}
     */
    Config.fetchApollo = function (config, ifCache, forceInit) {
        return __awaiter(this, void 0, void 0, function () {
            var storedConfig, res, conf, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (forceInit) {
                            Config.inited = false;
                        }
                        if (Config.inited)
                            return [2 /*return*/, Promise.resolve()];
                        if (!!config) return [3 /*break*/, 9];
                        Config.inited = true;
                        return [4 /*yield*/, Config.getFromIndexedDB(constants_1.ConfigMap.ELVISHCONFIG)];
                    case 1:
                        storedConfig = _a.sent();
                        if (!(storedConfig && ifCache && typeof window !== 'undefined')) return [3 /*break*/, 7];
                        Config.apollo = storedConfig;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, axios_1.default.get(helper_1.apolloCDNPath)];
                    case 3:
                        res = _a.sent();
                        return [4 /*yield*/, res.data];
                    case 4:
                        conf = _a.sent();
                        Config.storeConfigInIndexedDB(constants_1.ConfigMap.ELVISHCONFIG, conf)
                            .then(function () { return console.log("".concat(constants_1.ConfigMap.ELVISHCONFIG, "\u6570\u636E\u5B58\u50A8\u6210\u529F\uFF01")); })
                            .catch(function (error) {
                            console.warn("".concat(constants_1.ConfigMap.ELVISHCONFIG, "\u6570\u636E\u5B58\u50A8\u5931\u8D25:"), error);
                            Config.handleError(error);
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        console.warn('Elvish Warning: update apollo indexedDB error', err_1);
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7: return [2 /*return*/, Config.handleGetFromApolloError()];
                    case 8: return [2 /*return*/, Promise.resolve()];
                    case 9:
                        Config.apollo = config;
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    /**
     * 格式化init参数
     * @return {Record<string, any>}
     */
    Config.getInitParams = function (locale, countryOrIfCacheOrConfigOrOptions, configOrIfCacheOrOptions, ifCacheOrOptions, options) {
        var configObject = {
            locale: locale,
            country: countryOrIfCacheOrConfigOrOptions,
            config: configOrIfCacheOrOptions,
            ifCache: ifCacheOrOptions
        };
        // init(locale, ifCache)
        if (typeof countryOrIfCacheOrConfigOrOptions === 'boolean') {
            configObject.ifCache = countryOrIfCacheOrConfigOrOptions;
            configObject.country = undefined;
        }
        // init(locale, country, config, options)
        if (typeof ifCacheOrOptions === 'object') {
            // forceInit为true，则强制init，不管之前有没有init过
            if (ifCacheOrOptions.country ||
                ifCacheOrOptions.config ||
                ifCacheOrOptions.ifCache ||
                ifCacheOrOptions.forceInit) {
                options = ifCacheOrOptions;
                configObject.ifCache = true;
            }
        }
        // init(locale, country, ifCache)
        if (typeof configOrIfCacheOrOptions === 'boolean') {
            configObject.ifCache = configOrIfCacheOrOptions;
            configObject.config = undefined;
        }
        // init(locale, country, options)
        if (typeof configOrIfCacheOrOptions === 'object' &&
            (configOrIfCacheOrOptions.country ||
                configOrIfCacheOrOptions.config ||
                configOrIfCacheOrOptions.ifCache !== undefined ||
                configOrIfCacheOrOptions.forceInit)) {
            options = configOrIfCacheOrOptions;
            configObject.config = undefined;
        }
        // init(locale, config or options)
        if (countryOrIfCacheOrConfigOrOptions &&
            typeof countryOrIfCacheOrConfigOrOptions !== 'string' &&
            typeof countryOrIfCacheOrConfigOrOptions !== 'boolean') {
            // init(locale, options)
            if (typeof countryOrIfCacheOrConfigOrOptions === 'object' &&
                (countryOrIfCacheOrConfigOrOptions.country ||
                    countryOrIfCacheOrConfigOrOptions.config ||
                    countryOrIfCacheOrConfigOrOptions.ifCache !== undefined ||
                    countryOrIfCacheOrConfigOrOptions.forceInit)) {
                options = countryOrIfCacheOrConfigOrOptions;
            }
            else {
                // init(locale, config)
                configObject.config = countryOrIfCacheOrConfigOrOptions;
            }
            configObject.country = undefined;
        }
        // init(locale, country, config, ifCache, options)
        if (options && typeof options === 'object') {
            if (options.ifCache !== undefined) {
                configObject.ifCache = options.ifCache;
            }
            if (options.country) {
                configObject.country = options.country;
            }
            if (options.config) {
                configObject.config = options.config;
            }
        }
        return configObject;
    };
    /**
     * 格式化local
     * @return {void}
     */
    Config.normalizeLocale = function () {
        var countryToLocale = {
            CR: 'es_CR',
            PA: 'es_PA',
            DO: 'es_DO'
        };
        // 检查 Config.locale 是否为 'es_CO' 或 'es-CO'
        if (['es_CO', 'es-CO'].includes(Config.locale)) {
            if (Config.country && countryToLocale[Config.country]) {
                Config.locale = countryToLocale[Config.country];
            }
        }
        Config.locale = (Config.locale || '').replace('_', '-');
    };
    /**
     * 拉取阿波罗配置
     * @return {Promise<any>}
     */
    Config.getApollo = function () {
        return Config.fetchApollo(Config.config && Config.config.apollo, Config.ifCache, Config.options && Config.options.forceInit);
    };
    /**
     * 初始化度量衡
     * @return {Promise<any>}
     */
    Config.initDistance = function () {
        return distance.init();
    };
    /**
     * 初始化时间
     * @return {Promise<any>}
     */
    Config.initDate = function () {
        return date.init({
            config: Config.config,
            ifCache: Config.ifCache,
            forceInit: Config.options && Config.options.forceInit
        });
    };
    /**
     * 初始化电话
     * @return {Promise<any>}
     */
    Config.initPhone = function () {
        return phone.init({
            config: Config.config,
            ifCache: Config.ifCache,
            forceInit: Config.options && Config.options.forceInit
        });
    };
    return Config;
}());
exports.Config = Config;
/**
 * elvish初始化
 * @return {Promise<any>}
 */
function initV2(configObject) {
    Config.initData(configObject);
    Config.normalizeLocale();
    return Promise.all([
        Config.getApollo(),
        Config.initDistance(),
        Config.initDate(),
        Config.initPhone()
    ]);
}
exports.initV2 = initV2;
/**
 * elvish初始化
 * @return {Promise<any>}
 */
function init(locale, countryOrIfCacheOrConfigOrOptions, configOrIfCacheOrOptions, ifCacheOrOptions, options) {
    var res = Config.getInitParams(locale, countryOrIfCacheOrConfigOrOptions, configOrIfCacheOrOptions, ifCacheOrOptions, options);
    return initV2(res);
}
exports.init = init;
var fetchReloadCache = function (url) {
    return axios_1.default.get(url, 
    // reload 表示本次请求忽略浏览器已经有的缓存（相当于 Ctrl + R 强制刷新），
    // 但本次请求的结果还是会遵循响应的 Cache-Control 标头的值来进行缓存存储
    {
        headers: {
            'Cache-Control': 'no-cache'
        }
    });
};
exports.fetchReloadCache = fetchReloadCache;
exports.default = Config;
